import { type PaginationState } from "@kazaar-platform/design-system";
import { useState } from "react";

import { type CustomSortingState } from "@/helpers/tables";
import { useGetCurrentTasksByPhase } from "@/hooks";

type CurrentOrdersPhaseProps = {
  phase?: "order-definition" | "production-launch" | "all";
};

export const useCurrentTasksByPhase = ({
  phase = "all",
}: CurrentOrdersPhaseProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState<CustomSortingState | undefined>(
    undefined
  );

  const {
    data: currentTasksByPhaseData,
    isLoading: isCurrentTasksByPhaseLoading,
  } = useGetCurrentTasksByPhase({
    phase,
    limit: pagination.pageSize,
    offset: (pagination.pageIndex - 1) * pagination.pageSize,
  });

  return {
    currentTasksByPhase: currentTasksByPhaseData?.data?.page || [],
    totalRows: currentTasksByPhaseData?.data?.total || 0,
    isLoading: isCurrentTasksByPhaseLoading,
    pagination,
    sorting,
    setPagination,
    setSorting,
  };
};
